import React from "react";
import passaros from '../../assets/passaros.png';
import './style.css'

const Local = () => {
  const { innerWidth: width } = window;
  return (
    <div id="local" className="local-section">
      <img className="passaros" src={passaros} />
      <h2>Local da Cerimônia</h2>
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3716.5866357891955!2d-45.75172540480301!3d-21.32734394236084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDE5JzM5LjMiUyA0NcKwNDUnMDUuOSJX!5e0!3m2!1spt-BR!2sbr!4v1727300959749!5m2!1spt-BR!2sbr"
        width={width} 
        height="450" 
        style={{border:0}} 
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade"
      />
      <div>
        <p className="montserrat-300">Capela Nossa Senhora Aparecida -  Comunidade do Imbiruçu - Zona Rural de Córrego do Ouro</p>
      </div>
    </div>
  )
}

export default Local